import { Box, Flex, Grid, SimpleGrid, Text, Image } from "@chakra-ui/react";
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
import KarmaSliderComponent from "./KarmaSliderComponent";
import SimpleButton from '@components/Buttons/SimpleButton';
import ContentArea from "./ContentArea";
import Link from "next/link";
import { useBreakpointValue } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';


let KarmaBookExcerpt = ({ sectionContent, styleConfig, sectionId }) => {


    const isMobile = useMediaQuery({ maxWidth: 767 });

    return <Box
        pt={{ base: '60px', md: '100px', lg: '140px', }}
        pb={{ base: '30px', md: '100px', lg: '100px', }}
        bgImage={styleConfig?.bgImage?.url}
    >

        <Box display={'flex'} justifyContent={'center'} flexDir={'column'} alignItems={'center'} width={'100%'}>
            <Text
                fontWeight={500}
                fontSize={{ base: '34px', md: '60px' }}
                lineHeight={'60px'}
                color={'#B7870C'}
                textAlign={'left'}
                width={{ base: '88%', md: '657px', lg: '770px', 'xl': '770px' }}
                fontFamily={'var(--AustinMedium)'}
                mb={{ base: '20px', md: '90px', lg: '40px' }}
            >
                {sectionContent?.[0]?.titleText}
            </Text>
            
            <Box>
            <KarmaSliderComponent sectionContent={sectionContent?.[1]}
                width={{ base: '304px', md: '657px', lg: '657px', 'xl': '770px' }}
                height={{ base: '171px', md: '394px', lg: '394px', 'xl': '462px' }}
                prevArrRightPos={{ base: '-0.4rem', md: '-1.2rem' }}
                nextArrRightPos={{ base: '-0.4rem', md: '-1.2rem' }}
            />

            </Box>

            <Box
                mt={{ md: '40px' }}
                id={'karmaBookExcerpt'}
                width={{ base: '95%', md: '657px', lg: '770px', 'xl': '790px' }}
            >
                <ContentArea
                    tAlign={'left'}
                    fontFamily={'var(--FedraSansStd-book)'}
                    color={'#000000'}
                    mainContent={sectionContent?.[2]?.body?.value}
                    sectionContent={sectionContent?.[2]?.body}
                    font={{ base: '16px', md: '20px' }}
                    fontWeight={400}
                    lineHeight={{ base: '26px', md: "34px" }}
                    maxW={'100%'}
                />
            </Box>
        </Box>

        <style>
            {`
                #karmaBookExcerpt p:empty {
                margin-bottom: ${isMobile ? '1rem' : '2rem'};
            }            
            `}
        </style>
    </Box>

}

export default KarmaBookExcerpt;